"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerPropType = void 0;
/**
 * The types of analysis provided by PFF.
 *
 * @deprecated Use `PropBetType` instead.
 */
var PlayerPropType;
(function (PlayerPropType) {
    /**
     * Player vs Player analysis.
     */
    PlayerPropType["PlayerVersusPlayer"] = "PLAYER_VS_PLAYER";
    /**
     * A single player vs team unit analysis.
     */
    PlayerPropType["PlayerVersusTeam"] = "PLAYER_VS_TEAM";
})(PlayerPropType || (exports.PlayerPropType = PlayerPropType = {}));
//# sourceMappingURL=player_prop.js.map